// Mock data for IVARME Trading Company

export const products = {
  waterPumps: [
    {
      id: 'wp1',
      name: 'Industrial Centrifugal Pump',
      category: 'Water Pumps',
      hsnCode: '8413',
      description: 'Heavy-duty centrifugal pump suitable for industrial water supply, irrigation, and processing applications.',
      specifications: {
        power: '5-50 HP',
        flowRate: '50-500 m³/h',
        head: '20-100 m',
        material: 'Cast Iron/SS316'
      },
      applications: ['Industrial water supply', 'Irrigation', 'Processing plants'],
      image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800'
    },
    {
      id: 'wp2',
      name: 'Submersible Water Pump',
      category: 'Water Pumps',
      hsnCode: '8413',
      description: 'Efficient submersible pump for borewell and deep well applications with high reliability.',
      specifications: {
        power: '1-15 HP',
        flowRate: '10-100 m³/h',
        head: '30-200 m',
        material: 'Stainless Steel'
      },
      applications: ['Borewell pumping', 'Deep wells', 'Agricultural use'],
      image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=800'
    },
    {
      id: 'wp3',
      name: 'High-Pressure Booster Pump',
      category: 'Water Pumps',
      hsnCode: '8413',
      description: 'Multi-stage booster pump for high-rise buildings and pressure boosting applications.',
      specifications: {
        power: '3-25 HP',
        flowRate: '20-150 m³/h',
        head: '50-300 m',
        material: 'Stainless Steel 304'
      },
      applications: ['High-rise buildings', 'Water treatment plants', 'RO systems'],
      image: 'https://images.unsplash.com/photo-1581092918484-8313e1f7e8d4?w=800'
    }
  ],
  pipeFittings: [
    {
      id: 'pf1',
      name: 'HDPE Pipe Fittings',
      category: 'Pipe Fittings',
      hsnCode: '3917',
      description: 'High-density polyethylene fittings for water supply and industrial piping systems.',
      specifications: {
        size: '20mm - 630mm',
        pressure: 'PN 6 to PN 16',
        standard: 'ISO 4427',
        material: 'PE100'
      },
      types: ['Elbows', 'Tees', 'Reducers', 'Flanges', 'End Caps'],
      image: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800'
    },
    {
      id: 'pf2',
      name: 'PVC Pipe Fittings',
      category: 'Pipe Fittings',
      hsnCode: '3917',
      description: 'Durable PVC fittings for plumbing, drainage, and irrigation applications.',
      specifications: {
        size: '15mm - 315mm',
        pressure: 'PN 4 to PN 10',
        standard: 'IS 4985',
        material: 'UPVC/CPVC'
      },
      types: ['Couplers', 'Elbows', 'Tees', 'Valves', 'Unions'],
      image: 'https://images.unsplash.com/photo-1581092921461-eab62e97a780?w=800'
    },
    {
      id: 'pf3',
      name: 'Stainless Steel Fittings',
      category: 'Pipe Fittings',
      hsnCode: '3917',
      description: 'Corrosion-resistant SS fittings for chemical, pharmaceutical, and food processing.',
      specifications: {
        size: '6mm - 150mm',
        grade: 'SS304/SS316L',
        standard: 'ASME B16.11',
        connection: 'Threaded/Welded'
      },
      types: ['Elbows', 'Tees', 'Reducers', 'Couplings', 'Caps'],
      image: 'https://images.unsplash.com/photo-1565024158640-f8e0c2d5a6a4?w=800'
    }
  ],
  poolEquipment: [
    {
      id: 'pe1',
      name: 'Swimming Pool Circulation Pump',
      category: 'Pool Equipment',
      hsnCode: '8413',
      description: 'Energy-efficient pool circulation pump for residential and commercial pools.',
      specifications: {
        power: '0.5-3 HP',
        flowRate: '10-50 m³/h',
        voltage: '220V/380V',
        efficiency: 'IE3 Standard'
      },
      features: ['Corrosion resistant', 'Low noise', 'Easy maintenance', 'Energy efficient'],
      image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=800'
    },
    {
      id: 'pe2',
      name: 'Pool Sand Filter System',
      category: 'Pool Equipment',
      hsnCode: '8421',
      description: 'High-performance sand filter for crystal clear pool water.',
      specifications: {
        size: '400mm - 900mm',
        flowRate: '8-30 m³/h',
        material: 'Fiberglass/SS',
        pressure: '2.5 bar'
      },
      features: ['Multi-port valve', 'Pressure gauge', 'Drain plug', 'Easy backwash'],
      image: 'https://images.unsplash.com/photo-1519327232521-1ea2c736d34d?w=800'
    },
    {
      id: 'pe3',
      name: 'Pool Heat Pump',
      category: 'Pool Equipment',
      hsnCode: '8418',
      description: 'Energy-saving heat pump for maintaining optimal pool temperature.',
      specifications: {
        capacity: '12-50 kW',
        cop: '5.0-6.5',
        voltage: '220-380V',
        refrigerant: 'R410A'
      },
      features: ['Titanium heat exchanger', 'Digital control', 'Auto defrost', 'Low noise'],
      image: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800'
    }
  ],
  chemicals: [
    {
      id: 'ch1',
      name: 'Pool Chlorine Tablets',
      category: 'Water Treatment Chemicals',
      hsnCode: '3824',
      description: 'Slow-dissolving chlorine tablets for continuous pool sanitization.',
      specifications: {
        activeChlorine: '90% min',
        form: 'Tablets (200g)',
        packaging: '25kg, 50kg drums',
        cas: '87-90-1'
      },
      safety: 'SDS available for download',
      applications: ['Pool disinfection', 'Water treatment', 'Sanitization'],
      image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800'
    },
    {
      id: 'ch2',
      name: 'pH Balancing Chemicals',
      category: 'Water Treatment Chemicals',
      hsnCode: '3824',
      description: 'pH adjusters for maintaining optimal water chemistry.',
      specifications: {
        types: 'pH Plus / pH Minus',
        composition: 'Sodium Carbonate / Sodium Bisulfate',
        packaging: '5kg, 25kg bags',
        purity: '99% min'
      },
      safety: 'SDS available for download',
      applications: ['pH adjustment', 'Water balancing', 'Alkalinity control'],
      image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=800'
    },
    {
      id: 'ch3',
      name: 'Algaecide Solution',
      category: 'Water Treatment Chemicals',
      hsnCode: '3824',
      description: 'Effective algaecide for preventing and treating algae growth.',
      specifications: {
        activeIngredient: 'Quaternary Ammonium',
        concentration: '10-40%',
        packaging: '5L, 20L, 200L',
        form: 'Liquid'
      },
      safety: 'SDS available for download',
      applications: ['Algae prevention', 'Pool maintenance', 'Water clarification'],
      image: 'https://images.unsplash.com/photo-1603796846097-bee99e4a601f?w=800'
    }
  ]
};

export const engineeringServices = [
  {
    id: 'es1',
    title: 'CAD Production Drawings',
    nicCode: '71100',
    description: 'Detailed CAD drawings for manufacturing, fabrication, and production purposes.',
    capabilities: [
      '2D production drawings (AutoCAD, DraftSight)',
      '3D modeling and assemblies',
      'Bill of Materials (BOM) generation',
      'GD&T and tolerance specifications',
      'As-built documentation'
    ],
    standards: ['ISO 128', 'ASME Y14.5', 'IS 696'],
    deliverables: ['DWG/DXF files', 'PDF drawings', 'BOM in Excel', '3D models (STEP/IGES)'],
    icon: 'drafting-compass'
  },
  {
    id: 'es2',
    title: 'MEP Design Services',
    nicCode: '71100',
    description: 'Comprehensive Mechanical, Electrical, and Plumbing design for buildings and facilities.',
    capabilities: [
      'HVAC system design and layout',
      'Plumbing and firefighting systems',
      'Electrical distribution and lighting',
      'Load calculations and sizing',
      'Energy efficiency optimization'
    ],
    standards: ['NBC India', 'ASHRAE', 'BS Standards', 'CPHEEO Manual'],
    deliverables: ['MEP drawings', 'Equipment schedules', 'Calculation reports', 'Specifications'],
    icon: 'building'
  },
  {
    id: 'es3',
    title: 'Engineering Consultancy',
    nicCode: '71100',
    description: 'Expert engineering consultation for industrial and infrastructure projects.',
    capabilities: [
      'Feasibility studies and assessments',
      'System design and optimization',
      'Technical specifications development',
      'Vendor drawing review',
      'Project documentation support'
    ],
    standards: ['Client-specific requirements', 'International codes'],
    deliverables: ['Technical reports', 'Design recommendations', 'Specification documents', 'Review comments'],
    icon: 'clipboard-check'
  }
];

export const regions = [
  {
    name: 'Vietnam',
    icon: 'map-pin',
    description: 'Primary market with AIFTA benefits for cost-effective exports.',
    advantages: [
      'Zero-duty access under ASEAN-India FTA',
      'Fast shipping from Chennai/Mumbai ports',
      'Local language support (Vietnamese)',
      'Established logistics partners'
    ],
    incoterms: ['FOB', 'CIF', 'CFR'],
    ports: ['Ho Chi Minh', 'Hai Phong', 'Da Nang']
  },
  {
    name: 'Middle East',
    icon: 'globe',
    description: 'Serving UAE, Saudi Arabia, Oman, and Qatar with quality products.',
    advantages: [
      'Competitive pricing for bulk orders',
      'Express shipping to Jebel Ali, Dammam',
      'Technical support in Arabic/English',
      'Compliance with GCC standards'
    ],
    incoterms: ['FOB', 'CIF', 'DDU'],
    ports: ['Jebel Ali', 'Dammam', 'Muscat', 'Doha']
  },
  {
    name: 'Africa',
    icon: 'map',
    description: 'Expanding presence in East and West Africa markets.',
    advantages: [
      'Flexible payment terms',
      'Consolidated shipments available',
      'Support for customs clearance',
      'Quality products at competitive rates'
    ],
    incoterms: ['FOB', 'CIF', 'CNF'],
    ports: ['Lagos', 'Mombasa', 'Dar es Salaam', 'Durban']
  },
  {
    name: 'India (Domestic)',
    icon: 'home',
    description: 'Serving domestic industrial and infrastructure sectors.',
    advantages: [
      'GST-compliant invoicing',
      'Nationwide delivery network',
      'After-sales support',
      'Local warranty coverage'
    ],
    incoterms: ['Ex-Works', 'FOR', 'Delivered'],
    ports: ['Pan-India delivery']
  }
];

export const testimonials = [
  {
    id: 't1',
    name: 'Nguyen Van Thanh',
    company: 'Hanoi Water Solutions Ltd.',
    country: 'Vietnam',
    text: 'IVARME has been our trusted partner for water pump imports. Their product quality and timely delivery have never disappointed us. The AIFTA benefits make them highly competitive.',
    rating: 5
  },
  {
    id: 't2',
    name: 'Ahmed Al-Mansoori',
    company: 'Gulf Engineering Contracting',
    country: 'UAE',
    text: 'The CAD drawings and MEP designs provided by IVARME are of exceptional quality. Their engineering team understands international standards perfectly.',
    rating: 5
  },
  {
    id: 't3',
    name: 'John Okafor',
    company: 'Lagos Industrial Supplies',
    country: 'Nigeria',
    text: 'Reliable supplier with competitive pricing. The pool equipment we imported has been performing excellently. Great communication throughout the export process.',
    rating: 5
  },
  {
    id: 't4',
    name: 'Priya Sharma',
    company: 'Bangalore Infrastructure Pvt Ltd',
    country: 'India',
    text: 'IVARME provided comprehensive MEP design services for our commercial project. Their attention to detail and adherence to NBC standards was impressive.',
    rating: 5
  }
];

export const faqs = [
  {
    category: 'Export & Logistics',
    questions: [
      {
        q: 'What are your supported Incoterms?',
        a: 'We support FOB, CIF, CFR, CNF, DDU, and Ex-Works terms depending on the destination and customer preference.'
      },
      {
        q: 'What is the typical lead time for export orders?',
        a: 'Lead times vary by product: standard pumps and fittings typically 4-6 weeks, specialized equipment 8-12 weeks from order confirmation.'
      },
      {
        q: 'Do you provide shipping and customs support?',
        a: 'Yes, we work with experienced freight forwarders and can assist with documentation, customs clearance, and logistics coordination.'
      },
      {
        q: 'What are the payment terms?',
        a: 'We offer flexible payment terms including LC (Letter of Credit), TT (Telegraphic Transfer), and for established clients, credit terms after initial transactions.'
      }
    ]
  },
  {
    category: 'Products & Quality',
    questions: [
      {
        q: 'Are your products certified?',
        a: 'Yes, our products comply with relevant international standards (ISO, ASME, IS). Specific certifications available upon request.'
      },
      {
        q: 'Do you provide Safety Data Sheets (SDS) for chemicals?',
        a: 'Absolutely. All chemical products come with comprehensive SDS documentation available for download on product pages.'
      },
      {
        q: 'Can I get customized products or specifications?',
        a: 'Yes, we can source customized products based on your technical specifications. Please submit an RFQ with your requirements.'
      },
      {
        q: 'What warranty do you offer?',
        a: 'Warranty terms vary by product type, typically 12-24 months from delivery. Specific warranty details provided with quotations.'
      }
    ]
  },
  {
    category: 'Engineering Services',
    questions: [
      {
        q: 'What software do you use for CAD drawings?',
        a: 'We use AutoCAD, SolidWorks, and DraftSight. We can deliver in multiple formats: DWG, DXF, PDF, STEP, IGES.'
      },
      {
        q: 'Do you follow international design standards?',
        a: 'Yes, we adhere to ISO 128, ASME Y14.5, NBC India, ASHRAE, and other relevant international codes based on project requirements.'
      },
      {
        q: 'What is the process for MEP design projects?',
        a: 'Our process: Requirement analysis → Preliminary design → Client review → Revisions → Final drawings → Documentation handover.'
      },
      {
        q: 'Can you review existing vendor drawings?',
        a: 'Yes, we offer drawing review and technical specification verification services as part of our engineering consultancy.'
      }
    ]
  }
];

export const certifications = [
  {
    name: 'Udyam Registration',
    description: 'Registered Indian Micro-Enterprise',
    icon: 'award'
  },
  {
    name: 'IEC Code',
    description: 'Import Export Code Holder',
    icon: 'shield-check'
  },
  {
    name: 'ISO 9001:2015',
    description: 'Quality Management System',
    icon: 'badge-check'
  },
  {
    name: 'ISO 14001:2015',
    description: 'Environmental Management',
    icon: 'leaf'
  }
];

export const partners = [
  {
    type: 'Manufacturing Partners',
    description: 'We work with certified manufacturers across India',
    locations: ['Gujarat', 'Maharashtra', 'Tamil Nadu', 'Delhi NCR']
  },
  {
    type: 'Logistics Partners',
    description: 'Reliable freight forwarders and shipping lines',
    services: ['Sea freight', 'Air freight', 'Customs clearance', 'Door delivery']
  },
  {
    type: 'Quality Assurance',
    description: 'Third-party inspection and testing services',
    certifications: ['ISO certified labs', 'Material testing', 'Performance verification']
  }
];

export const companyInfo = {
  name: 'IVARME Trading Company',
  tagline: 'Indian Excellence for Global Markets',
  email: 'contact@ivarme.com',
  phone: '+91-9600949276',
  whatsapp: '+91-9600949276',
  zalo: '[Zalo ID/Number]',
  address: 'Door No. 9D2, 5th cross street, K.R.G Nagar, Ganapathy, Coimbatore, Tamil Nadu, India - 641006',
  gst: 'GSTIN: 33CODPM8397H1ZI',
  iec: 'IEC: CODPM8397H',
  udyam: 'Udyam: UDYAM-TN-03-0292557'
};
